export function calculation(data, input, feedback) {
  const { questions, values } = data;
  // Go through each question
  questions.forEach(question => {
    // Look at each option
    question.options.forEach(option => {
      // If the option.label is found in the input
      if (input[question.question].indexOf(option.label) !== -1) {
        // Go through each value in Option
        // Add the values found in option to the values object
        Object.keys(option.value).forEach(value => {
          return (values[value] = values[value] + option.value[value]);
        });
      }
    });
  });
  // Send feedback.body and the values through final Feedback
  return finalFeedback(feedback.body, values);
}

const finalFeedback = (feedback, values) => {
  // Look for the double {{}}, and take that key out. Then replace the word with the values[key]
  return feedback.replace(/{{(\w+)}}/g, (match, key) => {
    if (key in values) {
      return values[key];
    }
    return '';
  });
};



// WEBPACK FOOTER //
// ../core/src/utils/calculation.js